import React from "react";

import { iProductGroup } from "../store";
import GroupTreeItem from "./GroupTreeItem";

interface Props {
    productGroups: iProductGroup[];
    selectedProductTree: number[];
    selectGroup: (group: iProductGroup) => void;
}

const GroupTree = ({
    productGroups,
    selectedProductTree,
    selectGroup,
}: Props) => {
    return (
        <div>
            {productGroups.map((group) => (
                <GroupTreeItem
                    key={group.id}
                    selectGroup={selectGroup}
                    productGroup={group}
                    selectedProductTree={selectedProductTree}
                />
            ))}
        </div>
    );
};

export default GroupTree;
